import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { FinancialTransactionService } from '../../../shared/services/financial-transaction.service';

@Component({
  selector: 'app-financial-transactions-export',
  templateUrl: './financial-transactions-export.component.html',
  styleUrls: ['./financial-transactions-export.component.scss']
})

export class FinancialTransactionsExportComponent implements OnInit {

  @Input() companyId: number;
  fromDate: string;
  toDate: string;

  constructor(protected financialTransactionService: FinancialTransactionService, private toastrService: ToastrService, public activeModal: NgbActiveModal, private modalService: NgbModal, public datePipe: DatePipe) {
  }

  ngOnInit() {
    this.resetForm();
  }

  resetForm(form?: NgForm) {
    // The datepicker control returns a stringvalue for the selected dates. Therefore the string types are used here for the fromDate and toDate variables.
    this.fromDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.toDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');

    if (form != null) {
      form.reset();
    }
  }

  closeModal() {
    this.activeModal.close();
  }

  onSubmit(form: NgForm) {
    this.financialTransactionService.getExportResult(this.companyId, this.fromDate, this.toDate);
  }
}
